"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fromHtml_1 = require("./fromHtml");
var isHTMLElement_1 = require("../typeUtils/isHTMLElement");
var isNode_1 = require("../typeUtils/isNode");
function wrap(nodes, wrapper) {
    nodes = !nodes ? [] : isNode_1.default(nodes) ? [nodes] : nodes;
    if (nodes.length == 0 || !nodes[0]) {
        return null;
    }
    if (!isHTMLElement_1.default(wrapper)) {
        var document_1 = nodes[0].ownerDocument;
        wrapper = wrapper || 'div';
        wrapper = /^\w+$/.test(wrapper)
            ? document_1.createElement(wrapper)
            : fromHtml_1.default(wrapper, document_1)[0];
    }
    var parentNode = nodes[0].parentNode;
    if (parentNode) {
        parentNode.insertBefore(wrapper, nodes[0]);
    }
    for (var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
        var node = nodes_1[_i];
        wrapper.appendChild(node);
    }
    return wrapper;
}
exports.default = wrap;
//# sourceMappingURL=wrap.js.map